import React from 'react'
import { FormTable, FormTableRow } from './FormTable'
import { Stack } from '@mui/material'
import { RegisteredCheckBox } from '../../../components/fields/CheckBox'
import { useFormContext } from 'react-hook-form'
import { RegisteredIsinField } from '../../../components/fields/IsinField'
import { ShouldShowAny } from '../../../components/entities/IssueType'
import { FormIssueEntity } from '../types/FormIssueEntity'

function IssueIsinDetails({
    issue,
    setIsCustomFormDirty,
}: {
    issue: FormIssueEntity
    setIsCustomFormDirty: (v: boolean) => void
}) {
    const formMethods = useFormContext()
    const [isinUnits, setIsinUnits] = React.useState(formMethods.getValues('isinUnits'))
    const [noIsinUnitsChecked, setNoIsinUnitsChecked] = React.useState(formMethods.getValues('noIsinUnits') || false)

    return (
        <FormTable>
            <ShouldShowAny issueType={issue.type} issueFields='isinRights, isinUnits, noIsinUnits'>
                <FormTableRow label='ISIN-koder'>
                    <Stack direction='row' spacing={2}>
                        <RegisteredIsinField
                            issueId={formMethods.getValues('id')}
                            label='ISIN för rätter'
                            name='isinRights'
                        />
                        <RegisteredIsinField
                            label='ISIN för units'
                            name='isinUnits'
                            issueId={formMethods.getValues('id')}
                            disabled={!!noIsinUnitsChecked}
                            onChangeValue={(newVal) => setIsinUnits(newVal)}
                        />
                        <RegisteredCheckBox
                            label='Inga BTA/BTU'
                            name='noIsinUnits'
                            disabled={!!isinUnits}
                            onChange={(event) => {
                                setNoIsinUnitsChecked(event.target.checked)
                                setIsCustomFormDirty(true)
                            }}
                        />
                    </Stack>
                </FormTableRow>
            </ShouldShowAny>
        </FormTable>
    )
}

export default IssueIsinDetails
